import { BounceZoomIn, BounceZoomOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition"
import Contract from "slotworks/utils/contract"
import { parallel } from "slotworks/utils/race-utils";
import { FadeInLayersCommand, FadeOutLayersCommand } from "commands/fade-layers-command";
import HarleyComponents from "components/components";
import soundManager from "slotworks/sound/sound-manager";
import deviceInfo from "slotworks/utils/device-info";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";

export default class FreespinsExitTransitions extends AbstractSceneTransition {

    public static ZOOM_TIME = 600;
    public static FADE_TIME = 600;

    public in(): Contract<void> {
        return parallel([
            () => Contract.wrap(() => {
                if(deviceInfo.isDesktop || canvasManager.orientation === Orientation.LANDSCAPE) 
                    soundManager.customEvent("free_spins_results_land");
                else
                    soundManager.customEvent("free_spins_results_port");
            }),
            () => this.zoomInPrompt(),
            () => this.fadeOutGame(),
            () => this.fadeInHarley(),
        ]);
    }

    public out(): Contract<void> {
        return parallel([
            () => this.zoomOutPrompt(),
            () => this.fadeInGame(),
            () => this.fadeOutHarley(),
        ]);
    }

    private zoomInPrompt() {
        return BounceZoomIn(Layers.Prompts.container, FreespinsExitTransitions.ZOOM_TIME);
    }

    private fadeInHarley() {
        return new Contract((resolve) => {
            HarleyComponents.harley.show();
            HarleyComponents.harley.clap(true);
            resolve(null);
        });
    }

    private fadeOutGame() {
        Layers.Custom.get("MatrixAnim").hide();
        Layers.Custom.get("MatrixNeon").hide();
        Layers.BetBar.hide();
        Layers.SmartButton.hide();
        Layers.SymbolAnimations.hide();
        return FadeOutLayersCommand([
            Layers.MatrixBackground,
            Layers.MatrixContent,
            Layers.MatrixForeground,            
            Layers.Banners,
            Layers.Footer,
            Layers.Custom.get("BonusBuyButton"),
            Layers.Custom.get("Messages"),                        
        ], FreespinsExitTransitions.FADE_TIME);
    }

    // out

    private zoomOutPrompt() {
        return new Contract((resolve) => {
            soundManager.customEvent("plaque_exit");
            BounceZoomOut(Layers.Prompts.container, FreespinsExitTransitions.ZOOM_TIME).then(resolve);
        });
    }

    private fadeOutHarley() {
        return new Contract((resolve) => {
            HarleyComponents.harley.hide();
            resolve(null);
        });
    }

    private fadeInGame() {
        return FadeInLayersCommand([
            Layers.MatrixBackground,
            Layers.MatrixContent,
            Layers.MatrixForeground,
            Layers.SymbolAnimations,
            Layers.BetBar,
            Layers.SmartButton,
            Layers.Banners,
            Layers.Footer,
            Layers.Custom.get("BonusBuyButton"),
            Layers.Custom.get("Messages"),
            Layers.Custom.get("MatrixNeon")
        ], FreespinsExitTransitions.FADE_TIME);
    }
}